import { AxiosError } from 'axios';
import { Asset } from 'modules/cm/api/cases/assets/types';
import { CaseError } from 'modules/cm/domain/Case/Error';
import { CaseDetails, CaseStatus, Liability } from 'modules/cm/pages/CaseDetailsPage/CaseDetailsPage.types';
import { ValidationError as PepperValidationError } from 'modules/cm/pages/CaseDetailsPage/Pepper/errors/PepperValidationError';
import { PepperReview } from 'modules/cm/store/cases/pepperReview/types';
import { Products } from 'modules/cm/store/cases/products/types';
import { Underwriting } from 'modules/cm/store/cases/underwriting/types';
import { RootState } from 'store/configureStore';
import { Nullable } from 'utils/types';
import { State as OriginalState } from '../core/types';
import { ACTION_TYPES as CASE_ERRORS_ACTION_TYPES } from './caseErrors/types';
import { ACTION_TYPES as CASE_HISTORY_ACTION_TYPES } from './caseHistory/types';
import { ACTION_TYPES as DUE_DILIGENCE_ACTION_TYPES } from './dueDiligence/types';
import { ACTION_TYPES as PEPPER_REVIEW_ACTION_TYPES } from './pepperReview/types';
import { ACTION_TYPES as PERMISSION_ACTION_TYPES } from './permission/types';
import { ACTION_TYPES as PRODUCTS_ACTION_TYPES } from './products/types';
import { ACTION_TYPES as READONLY_FIELDS_ACTION_TYPES } from './readonlyFields/types';
import { ACTION_TYPES as REFRESH_ACTION_TYPES } from './refresh/types';
import { ACTION_TYPES as UW_ACTION_TYPES } from './underwriting/types';

/*
@todo remove ApplicantAssetData and ApplicantLiabilityData and replace with ApplicantItem<T>
export type ApplicantItem<T> = { applicantId: number; item: T };
*/
export interface CaseErrorDetails {
  details: { detail: any };
  errorCode: string;
}
export type ApplicantAssetData = { applicantId: number; asset: Asset };
export type ApplicantLiabilityData = { applicantId: number; liability: Liability };
export type State = OriginalState<CaseDetails, Nullable<AxiosError<CaseErrorDetails>>, Nullable<CaseError>>;
export type Action<
  T =
    | CaseDetails
    | ApplicantAssetData
    | ApplicantLiabilityData
    | { fieldName: string; value: any }
    | State['processedFields'][0]
    | State['readonlyFields']
    | State['refresh']['fieldsToRefresh']
    | Underwriting
    | PepperReview
    | Products
    | PepperValidationError
    | Nullable<string>
    | CaseStatus
    | boolean
> = {
  type: ActionType;
  payload: [Nullable<T>, Nullable<AxiosError<CaseErrorDetails>>];
};

export type GetState = () => {
  currentCase: State;
  repaymentStrategy: RootState['repaymentStrategy'];
};

export type ActionType =
  | ACTION_TYPES.ERROR
  | ACTION_TYPES.SET_ERROR_MODAL
  | ACTION_TYPES.CLEAR_ERROR_MODAL
  | ACTION_TYPES.PENDING
  | ACTION_TYPES.SUCCESS
  | ACTION_TYPES.SUCCESS_ONE
  | ACTION_TYPES.SET_CASE_STATUS
  | ACTION_TYPES.SAVING_START
  | ACTION_TYPES.SAVING_FINISHED
  | DUE_DILIGENCE_ACTION_TYPES.SET_DUE_DILIGENCE_STATUS
  // readonly fields action types
  | READONLY_FIELDS_ACTION_TYPES.SET_READONLY_FIELDS
  | READONLY_FIELDS_ACTION_TYPES.SET_PEPPER_UPLOAD_DATE
  | CASE_HISTORY_ACTION_TYPES.PUSH
  | REFRESH_ACTION_TYPES.REFRESH
  | REFRESH_ACTION_TYPES.RESET
  // underwriting action types
  | UW_ACTION_TYPES.STORE_UW_SUCCESS
  // Permission action types
  | PERMISSION_ACTION_TYPES.SET_IS_READONLY
  | PERMISSION_ACTION_TYPES.SET_IS_NOT_READONLY
  | PEPPER_REVIEW_ACTION_TYPES.STORE_PEPPER_REVIEW_SUCCESS
  | PRODUCTS_ACTION_TYPES.STORE_PRODUCTS_SUCCESS
  // CaseErrors
  | CASE_ERRORS_ACTION_TYPES.SET_CASE_ERRORS;

export enum ACTION_TYPES {
  SUCCESS = 'CM/CASE/SUCCESS',
  SUCCESS_ONE = 'CM/CASE/SUCCESS_ONE',
  ERROR = 'CM/CASE/ERROR',
  SET_ERROR_MODAL = 'CM/CASE/SET_ERROR_MODAL',
  CLEAR_ERROR_MODAL = 'CM/CASE/CLEAR_ERROR_MODAL',
  PENDING = 'CM/CASE/PENDING',

  SUCCESS_PATCH = 'CM/CASE/PATCH/SUCCESS',
  SET_CASE_STATUS = 'CM/CASE/SET_STATUS',

  SAVING_START = 'CM/CASE/SAVING/START',
  SAVING_FINISHED = 'CM/CASE/SAVING/FINISHED',
}
